<template>
    <div>
        <common-table :table-columns="tableColumns" :form-fields="formFields" :url="url" :permission="permission" :operate="[]" :searchs="[]"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "UserAddress",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'userAddress:add',
                    update: 'userAddress:update',
                    delete: 'userAddress:delete',
                    deleteBatch: 'userAddress:deleteBatch'
                },
                url: {
                    get: '/userAddress/listByCondition',
                    add: '/userAddress/add',
                    update: '/userAddress/update',
                    delete: '/userAddress/delete',
                    delete_batch: '/userAddress/deleteBatch',
                    status: '/userAddress/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'userId',
                    label: '用户昵称',
                    selectUrl:'/userInfo/getAll',
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'address',
                    label: '地址',
                    show: true,
                    width: '',
                },{
                    field: 'siteId',
                    label: '绑定网站',
                    selectUrl: '/siteInfo/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: true,
                    detail: false,
                    width: '90',
                    status: true,
                }],
                formFields: {
                    addTitle: '添加用户地址',
                    updateTitle: '修改用户地址',
                    labelWidth: '90px',
                    model: [{
                        field: 'userId',
                        label: '会员：',
                        type: 'select',
                        selectUrl: '/userInfo/getAll',
                        selectData: [],
                        placeholder: '请选择会员',
                        rules:[{
                            message: '请选择会员', trigger: 'blur', required: true
                        }],
                        filterable: true,
                        add: true,
                        update: {
                            disabled: true
                        },
                    }, {
                        field: 'address',
                        label: '地址',
                        type: 'input',
                        placeholder: '地址',
                        rules: [{
                            message: '请输入地址', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
